import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { RatingBanner } from '../../components/RatingBanner';
import { getRegion } from '../../selectors/filters/getRegion';
import { getUrlById } from '../TitleContainer/utils';

export const RatingBannerContainer: React.FunctionComponent = () => {
  const { id } = useSelector(getRegion, shallowEqual);
  const deviceType = useDeviceType();
  const { config } = useApplicationContext();
  const href = getUrlById(id, config);

  if (deviceType !== 'phone' || !href) {
    return null;
  }

  return <RatingBanner href={href} />;
};
